export const OVERVIEW_DUMMY_DATA = [
  {
    title: "Q3 Marketing Campaign Hub",
    spaceName: "Marketing",
    authorName: "Lucas Miller",
    description:
      "A central space to plan, track, and align all assets and deliverables for the upcoming Q3 product launch...",
    modifiedDate: "Apr 16, 2025",
    numberOf: { likes: 124, comments: 8 },
  },
  {
    title: "New Hire Onboarding Portal",
    spaceName: "IT & Support Hub",
    authorName: "Emma Larsson",
    description:
      "A clean, interactive onboarding guide for new employees, featuring welcome messages, key policies, IT setup steps, and...",
    modifiedDate: "Apr 26, 2025",
    numberOf: { likes: 10, comments: 2 },
  },
  {
    title: "Design System Overview",
    spaceName: "Design & Brand studio",
    authorName: "Rajiv Mehta",
    description:
      "A shared resource outlining the company's design principles, UI components, and branding standards to ensure consistency...",
    modifiedDate: "May 10, 2025",
    numberOf: { likes: 10, comments: 1 },
  },
];
